export default __webpack_public_path__ + "c81d1b2a4b75d3eded6059a210910a6b.woff2";